var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessAnywhere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4839",
    "data-name": "Rectangle 4839",
    width: 30,
    height: 20,
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10126",
    "data-name": "Group 10126",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10125",
    "data-name": "Group 10125",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5677",
    "data-name": "Path 5677",
    d: "M12.515,16a.474.474,0,0,1,.484.525.48.48,0,0,1-.5.472h-3a3.758,3.758,0,0,1-.8,2l3.855,0a.5.5,0,0,1,0,1H6.44A.5.5,0,0,1,6.434,19L7.3,19a3.236,3.236,0,0,0,1.207-2L1.556,17A1.5,1.5,0,0,1,0,15.553V1.438A1.471,1.471,0,0,1,1.439,0H20.551a1.487,1.487,0,0,1,1.44,1.544A.475.475,0,0,1,21.469,2c-.7-.03-.272-1-.932-1L1.454,1A.47.47,0,0,0,1,1.452L.993,12H12.546a.471.471,0,0,1,.453.47.476.476,0,0,1-.453.525L1,13,1,15.547a.463.463,0,0,0,.449.447Z",
    transform: "translate(0 0)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M18.718,14.4a.475.475,0,0,1,.473.475.469.469,0,0,1-.44.521l-6.556.005.007,2.551a.463.463,0,0,0,.446.445l6.1.009a.461.461,0,0,1,.44.466.469.469,0,0,1-.439.521l-6,.01a1.492,1.492,0,0,1-1.546-1.386V3.777a1.447,1.447,0,0,1,1.362-1.369l9.19-.009a1.463,1.463,0,0,1,1.429,1.426l0,3.131a.469.469,0,0,1-.465.44.483.483,0,0,1-.527-.44L22.191,5.4h-10v9Zm3.463-10,.007-.554a.475.475,0,0,0-.449-.446h-9.09a.455.455,0,0,0-.448.446l0,.554Z",
    transform: "translate(2.801 0.6)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M23.872,18.194l-3.919,0a1.5,1.5,0,0,1-1.55-1.444V8.634A1.457,1.457,0,0,1,19.827,7.2h4.132A1.489,1.489,0,0,1,25.4,8.76l-.007,7.932a1.493,1.493,0,0,1-1.52,1.5m.514-9V8.643a.455.455,0,0,0-.441-.446h-4.1a.454.454,0,0,0-.441.446V9.2ZM24.4,15.19v-5h-5v5Zm-.48,2a.451.451,0,0,0,.469-.439v-.561H19.4v.557a.458.458,0,0,0,.442.446Z",
    transform: "translate(4.601 1.801)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5680",
    "data-name": "Path 5680",
    d: "M2.59,9.128a.464.464,0,0,1-.467.466.465.465,0,0,1-.52-.436L1.594,6.1a.5.5,0,1,1,1,0Z",
    transform: "translate(0.398 1.398)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M13.791,11.528a.5.5,0,0,1-.987.03L12.8,8.5a.5.5,0,1,1,1,0Z",
    transform: "translate(3.199 1.998)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M9.588,12.183H8.379c-.281,0-.412-.291-.4-.518A.5.5,0,0,1,8.5,11.2l1.059.006a.494.494,0,0,1,.029.977",
    transform: "translate(1.995 2.799)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M2.59,4.73a.463.463,0,0,1-.466.467A.464.464,0,0,1,1.6,4.758L1.6,3.7a.5.5,0,1,1,1,0Z",
    transform: "translate(0.399 0.798)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M13.791,7.131a.5.5,0,0,1-.987.029L12.8,6.1a.5.5,0,1,1,1,0Z",
    transform: "translate(3.199 1.398)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M16.834,14.568l-1.25.007c-.271,0-.4-.291-.385-.506a.456.456,0,0,1,.437-.466h1.119a.452.452,0,0,1,.435.411c.03.211-.066.552-.356.554",
    transform: "translate(3.8 3.401)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessAnywhere);
export default __webpack_public_path__ + "static/media/Access_anywhere.f5b71ecef3e70684115d88c417af545e.svg";
export { ForwardRef as ReactComponent };